<template>
  <div
    class="doctor-top flex"
    :class="{ 'space-between': hotList.length == 3 }"
  >
    <div
      class="doctor-top-item"
      :class="[
        'doctor-top-item' + item.topNo,
        { 'doctor-top-item1-right': hotList.length < 3 }
      ]"
      v-for="item in hotList"
      :key="item.topNo"
    >
      <i :class="'icon' + item.topNo"></i>
      <div class="doctor-top-border">
        <div
          class="doctor-top-pic"
          :style="{ backgroundImage: 'url(' + item.userHeadImage + ')' }"
        ></div>
      </div>
      <p>{{ item.userName }}</p>
      <div class="doctor-top-info c6 flex align-items">
        <template v-if="item.studyTime">
          <span class="font-24">{{ item.studyTime }}</span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
export default defineComponent({
  props: {
    hotList: {
      type: Array,
      default: () => []
    }
  }
})
</script>
<style lang="scss" scoped>
.doctor-top {
  display: flex;
  &.space-between {
    justify-content: space-between;
  }
}
.doctor-top-item {
  width: 1.85rem;
  height: 1.96rem;
  border-radius: 0.18rem 0.18rem 0 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  .doctor-top-info {
    display: flex;
    align-items: center;
    color: #666;
    height: 0.5rem;
    margin-top: 0.2rem;
    span {
      font-family: PingFangSC-Regular, PingFang SC;
      padding-right: 0.03rem;
      text-align: center;
    }
    strong {
      font-size: 24px;
      margin-top: 0.05rem;
    }
  }
  p {
    color: #232323;
    font-size: 28px;
    width: 100%;
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  i {
    width: 0.58rem;
    height: 0.58rem;
    background-repeat: no-repeat;
    background-size: 100% auto;
    position: relative;
    z-index: 100;
    margin-top: -0.13rem;
  }
  .icon1 {
    background-image: url('~@/assets/img/rank/doctor_top_icon1.png');
  }
  .icon2 {
    background-image: url('~@/assets/img/rank/doctor_top_icon2.png');
  }
  .icon3 {
    background-image: url('~@/assets/img/rank/doctor_top_icon3.png');
  }
}
.doctor-top-border {
  width: 1.09rem;
  height: 1.09rem;
  border-radius: 50%;
  position: absolute;
  padding: 0.04rem;
  left: 50%;
  top: 0;
  transform: translate(-50%, -75%);
}
.doctor-top-pic {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 50%;
}
.doctor-top-item2 {
  background: linear-gradient(
    to bottom,
    rgba(179, 197, 255, 0.4),
    rgba(179, 197, 255, 0)
  );
  .doctor-top-border {
    background-image: linear-gradient(
      155deg,
      rgba(230, 232, 235, 1),
      rgba(100, 101, 102, 1)
    );
  }
}
.doctor-top-item1-right {
  margin-right: 0.5rem;
}
.doctor-top-item1 {
  background: linear-gradient(
    to bottom,
    rgba(255, 204, 0, 0.4),
    rgba(2255, 204, 0, 0)
  );
  .doctor-top-border {
    width: 1.27rem;
    height: 1.27rem;
    background: linear-gradient(
      155deg,
      rgba(253, 220, 88, 1),
      rgba(255, 187, 0, 1)
    );
  }
}
.doctor-top-item3 {
  background: linear-gradient(
    to bottom,
    rgba(255, 203, 179, 0.4),
    rgba(255, 203, 179, 0)
  );
  .doctor-top-border {
    background: linear-gradient(
      155deg,
      rgba(255, 184, 112, 1),
      rgba(250, 145, 40, 1)
    );
  }
}
</style>
